import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatFormField, MatFormFieldModule} from '@angular/material/form-field';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatIcon} from '@angular/material/icon';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle} from '@angular/material/expansion';
import {ReferenceService} from '../../../apiModule1';


@Component({
    standalone: true,
    selector: 'pas-dialog-criterion',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss', '../../index-entity/dialog/dialog.component.scss', '../../index-entity/filling-method/filling-method.component.scss'],
    imports: [
        MatFormField,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        MatIcon,
        MatIconButton,
        MatButton,
        MatExpansionPanel,
        MatExpansionPanelHeader,
        MatExpansionPanelTitle,
    ]
})
export class DialogComponent implements OnInit {

    isNew: boolean = false;

    form = new FormGroup({
        name: new FormControl<string>('', [Validators.required]),
        shortName: new FormControl<string>('', [Validators.required]),
        weight: new FormControl<number | null>(null, [Validators.required]),
        period: new FormControl<CriterionPeriod>({id: 0, name: 'Годовая'}, [Validators.required]),
        multiSelect: new FormControl<string[]>([]),
        reportOrder: new FormControl<number>(0),
    })
    isEnabled: boolean = false;
    periods: CriterionPeriod[] = []


    constructor(
        public dialogRef: MatDialogRef<DialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Record<string, any>,
        private referenceService: ReferenceService
    ) {
        this.isNew = data['isNew'];
        this.initSelectors();
        // this.accessService.guide$.subscribe(v=>{
        //   this.isEnabled = v['group'];
        // });
        // this.dialogRef.afterClosed().subscribe(() => {
        //   this.router.navigate(['/group']);
        // });
        this.referenceService.apiReferencePeriodsGet().subscribe(({values}: { values: CriterionPeriod[] }) => {
            this.periods = values;
        })
    }


    onNoClick(): void {
        this.dialogRef.close();
    }

    private initSelectors(): void {
        this.form.get('name')!.setValue(this.data['name']);
        this.form.get('shortName')!.setValue(this.data['shortName']);
        this.form.get('weight')!.setValue(this.data['weight']);
        this.form.get('period')!.setValue(this.data['period'] || {id: 1, name: 'Годовая'} as CriterionPeriod);
        this.form.get('reportOrder')!.setValue(this.data['reportOrder']);
    }


    onApply() {
        if (this.form.invalid) return;
        const returnData: Criterion = {
            id: this.data['id'] || 0,
            name: this.form.get('name')!.value || '',
            shortName: this.form.get('shortName')!.value || '',
            weight: this.form.get('weight')!.value || 0,
            period: this.form.get('period')!.value || {id: 0, name: 'Годовая'} as CriterionPeriod,
            status: this.data['status'],
            reportOrder: this.form.get('reportOrder')?.value ?? 0,
        }
        this.dialogRef.close(returnData);
    }

    changePeriod(criterionPeriod: CriterionPeriod): void {
        this.form.get('period')!.setValue(criterionPeriod);
    }

    ngOnInit() {
        this.form.get('weight')!.valueChanges.subscribe(v => {
            if (v === null) return;
            this.form.get('weight')!.setValue(+v.toFixed(2));
        });
    }

}

